<!-- CARD RIFIUTI -->
<div class="app-card-box w-100 mt-md">

    <div class="d-flex ion-align-items-center ion-justify-content-between">
        <div class="d-flex ion-align-items-center">
            <div>
                <span class="material-symbols-rounded icon-medium text-green-600">compost</span>
            </div>
            <div class="m-none pl-xs ts-body-bold">{{ 'Gestione_rifiuti' | translate }}</div>
        </div>
    </div>

    <!-- IMPOSTAZIONE ZONA -->
    <div class="pt-ms">
        <div class="d-flex ion-align-items-center ion-justify-content-between">
            <div class="ts-body-semibold text-neutral-600">{{ 'Zona_rifiuti' | translate }}</div>
            <div>
                <ion-select [interfaceOptions]="{header: ('Zona_rifiuti' | translate)}"
                            [(ngModel)]="wasteService.userZone">
                    <ion-select-option value="-1">{{ 'Non_impostata' | translate }}</ion-select-option>
                    <ion-select-option value="1">Zona 1</ion-select-option>
                    <ion-select-option value="2">Zona 2</ion-select-option>
                    <ion-select-option value="3">Zona 3</ion-select-option>
                    <ion-select-option value="4">Zona 4</ion-select-option>
                </ion-select>
            </div>
        </div>
    </div>

    <!-- TROVA ZONA -->
    <div class="pt-ms" (click)="trovaZonaModal.present()">
        <div class="d-flex ion-align-items-center ion-justify-content-between">
            <div class="ts-body-semibold text-neutral-600">{{ 'Trova_la_tua_zona' | translate }}
            </div>
            <div>
                <span class="material-symbols-outlined ">chevron_right</span>
            </div>
        </div>
    </div>

    <!-- TROVA ZONA -->
    <div (click)="rifiutiIngombrantiModal.present()"
         class="pt-ms">
        <div class="d-flex ion-align-items-center ion-justify-content-between">
            <div class="ts-body-semibold text-neutral-600">{{ 'Rifiuti_ingombranti' | translate }}</div>
            <div>
                <span class="material-symbols-outlined ">chevron_right</span>
            </div>
        </div>
    </div>

</div>
<app-drawer-modal (getModalRef)="trovaZonaModal = $event"
                  [title]="'Trova zona rifiuti'">
    <div content>
        <div>
            <img src="assets/img/trova-zona-rifiuti.png"
                 style="height: 60px;"
                 class="w-100">
        </div>
        <div class="ts-small pt-xsm text-neutral-500">Esempio di foglietto informativo</div>
        <div class="ts-caption pt-ml">
            Per consultare correttamente il calendario dei rifiuti, ti invitiamo a verificare la zona di appartenenza
            indicata nel foglietto informativo ricevuto al momento della consegna delle attrezzature da parte del
            Comune.
        </div>
    </div>
</app-drawer-modal>
<app-drawer-modal (getModalRef)="rifiutiIngombrantiModal = $event"
                  [title]="'Ritiro rifiuti ingombranti'">
    <div content>
        <div>
            Per richiedere il ritiro gratuito presso il proprio domicilio di rifiuti ingombranti, sfalci e potature o
            rifiuti da apparecchiature elettriche e elettroniche (RAEE) è possibile contattare i seguenti numeri:
            <br>
            <br>
            <span class="ts-body-bold">Numero verde gratuito</span>
            <br>
            <br>
            <a class="ts-h5-sans" href="tel:800959304">800 959304</a> (da rete fissa)
            <br>
            <a class="ts-h5-sans" href="tel:3286955354">328 6955354</a> (da mobile e WhatsApp)
            <br>
            <br>
            Il rifiuto dovrà essere esposto presso la più vicina area pubblica raggiungibile da autocarri.
            <br>
            <br>
            In caso di conferimento di sfalci d'erba, gli stessi dovranno essere raccolti in fascine o inseriti in
            sacconi, per un massimo di 2 pezzi
        </div>
    </div>
</app-drawer-modal>
